<template>
    <div>
        <oc-button
            class="btn-outline-secondary refresh-btn"
            data-operation="refresh"
            @click="onRefresh"
            title="Refresh Data"
            icon="refresh"
        />

        <oc-dropdown :title="visualise(secondsRemaining, refreshMode)" align="right">
            <oc-button-input class="btn btn-outline-secondary refresh-btn" slot="button" slot-scope="{toggle}" @click="toggle">
                <oc-icon type="caret-down" />
                {{visualise(secondsRemaining, refreshMode)}}
                <oc-icon type="clock-o" />
            </oc-button-input>

            <template slot-scope="{hide}">
                <oc-button-input
                    class="dropdown-item" v-for="(option, value) in refreshOptions"
                    :key="value"
                    @mouseup="hide"
                    @click="select(value)"
                >
                    <a :data-operation="`refresh-${option}`">
                        <oc-icon type="check" :style="`color: ${value == secondsToCount ? 'black' : 'white'};`" />
                        {{ option }}
                    </a>
                </oc-button-input>
            </template>
        </oc-dropdown>
    </div>
</template>

<script>
export default {
    name: 'oc-auto-refresher',
    props: {
        default: {
            type: [String, Number],
            default: 0 // Off
        },
        refreshOptions: {
            type: Object,
            default: () => ({
                0: 'Off',
                30: '30 sec',
                60: '1 min',
                120: '2 min',
                180: '3 min',
                240: '4 min',
                300: '5 min'
            })
        }
    },
    data() {
        return {
            secondsToCount: 0,
            secondsRemaining: 0,
            refreshMode: false,
            myInterval: null
        }
    },
    mounted() {
        let defaultValue = parseInt(this.default)

        if( isNaN(defaultValue) ) {
            defaultValue = 0
        }

        this.select(defaultValue)
    },
    methods: {
        visualise(value, refreshMode) {
            if (refreshMode) {
                let minutes = Math.floor(value / 60)
                let seconds = (value % 60 > 9 ? '' : '0') + (value % 60)
                return `${minutes}:${seconds}`
            } else {
                return this.refreshOptions[0]
            }
        },
        onRefresh() {
            this.secondsRemaining = this.secondsToCount
            this.$emit('refresh')
        },
        select(chosen) {
            if (chosen > 0)
            {
                this.secondsToCount = chosen
                this.secondsRemaining = chosen

                if (!this.refreshMode)
                {
                    this.refreshMode = true
                    this.myInterval = setInterval(this.reduceTime, 1000)
                }
            }
            else
            {
                this.secondsToCount = 0
                this.secondsRemaining = 0
                this.refreshMode = false
                clearInterval(this.myInterval)
            }
        },
        reduceTime() {
            if (this.secondsRemaining > 0) {
                this.secondsRemaining--
            } else {
                this.onRefresh()
            }
        }
    }
}
</script>

<style scoped>
    /deep/.dropdown-item:hover {
        cursor: pointer;
        color: #000000;
    }
    /deep/.dropdown-item {
        padding-left: 10px !important;
        padding-right: 10px !important;
    }
    /deep/.dropdown-item.active, .dropdown-item:active {
        text-decoration: none;
        background-color: rgb(206, 212, 218);
    }
    /deep/.dropdown-menu {
        min-width: 6rem !important;
        padding: .5rem 0;
        margin: 0.1rem 0 0;
        font-size: 1rem;
    }
    .refresh-btn {
        padding: 5px 5px;
        border-color: rgb(206, 212, 218);
    }
</style>
